'use client';

import type { realestatelst } from '@ps/models/lib/realestate-listing-page';
import { AspectRatio } from '@ps/ui/atoms/aspect-ratio';
import { Image as ImageIcon } from 'lucide-react';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

import type { SlotWidth } from '../../widget-registry';

// ─── Constants ────────────────────────────────────────────────────────────

const GRID_COLS_BY_SLOT_WIDTH: Record<SlotWidth, string> = {
  narrow: 'grid-cols-3',
  wide: 'grid-cols-4',
  full: 'grid-cols-6',
};

// ─── Component ────────────────────────────────────────────────────────────

export function GalleryGrid({
  images,
  slotWidth,
}: {
  images: realestatelst.GalleryImage[];
  slotWidth: SlotWidth;
}) {
  const gridCols = GRID_COLS_BY_SLOT_WIDTH[slotWidth];

  return (
    <PhotoProvider>
      <div className={`grid ${gridCols} gap-2`}>
        {images.map(image => (
          <div key={image.id}>
            <AspectRatio
              ratio={1}
              className="overflow-hidden rounded-lg bg-gray-100 dark:bg-gray-800"
            >
              {image.url ? (
                <PhotoView src={image.url}>
                  <img
                    src={image.url}
                    alt={image.alt ?? 'Gallery image'}
                    className="h-full w-full cursor-zoom-in object-cover"
                    loading="lazy"
                  />
                </PhotoView>
              ) : (
                <div className="flex h-full w-full items-center justify-center">
                  <ImageIcon className="h-8 w-8 text-gray-300 dark:text-gray-600" />
                </div>
              )}
            </AspectRatio>
          </div>
        ))}
      </div>
    </PhotoProvider>
  );
}
